var _rect, _rect2, _circle, _circle2, _circle3, _path, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 47,
    viewBox: "0 0 72 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.36328,
    y: 7.36377,
    width: 64.6364,
    height: 39.2727,
    rx: 6,
    fill: "#027BC7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64.6364,
    height: 39.2727,
    rx: 6,
    fill: "#DADFF3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3635,
    cy: 19.6364,
    r: 10.2045,
    stroke: "#28345A",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 19.5,
    r: 9.5,
    fill: "#DADFF3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3635,
    cy: 16.3638,
    r: 3.27273,
    fill: "#28345A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7272 27.8182C23.7272 29.4546 20.0212 29.4546 15.9544 29.4546C11.8876 29.4546 9.40897 29.4546 8.99988 27.8182C8.99988 23.7514 12.2967 20.4546 16.3635 20.4546C20.4303 20.4546 23.7272 23.7514 23.7272 27.8182Z",
    fill: "#28345A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7275,
    y: 9.81812,
    width: 27.8182,
    height: 3.27273,
    fill: "#B5C0EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7275,
    y: 18,
    width: 23.7273,
    height: 3.27273,
    fill: "#B5C0EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7275,
    y: 26.1816,
    width: 16.3636,
    height: 3.27273,
    fill: "#B5C0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.a4bb1c9b2f391fdeb473716d6e341877.svg";
export { ForwardRef as ReactComponent };